import React from 'react';
import {
	styled,
	Form,
	FormItem,
	TextInput,
	Button
} from 'ps-gui';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';
import { formatHtml } from '../../utils';
import PhoneNumber from '../../../components/phonenumber';
import EmailAddress from '../../../components/emailaddress';

export default class ForgottenPasswordForm extends React.PureComponent {
	render() {
		const {data, createPasswordChangeAuthenticationCode, setProperty, reset} = this.props;

		return (
			<>
				<h1>{getPhrase('passwordReset')}</h1>
				<Form vertical onAction={createPasswordChangeAuthenticationCode} key="pwdReset1">
					<FormHint dangerouslySetInnerHTML={{ __html: formatHtml(getPhrase('passwordResetHint')) }} />
					<FormItem label={getFormItemLabel('userName')} error={data.get('userNameError')}>
						<TextInput
							value={data.get('userName') || ''}
							onChange={value => setProperty('userName', value)}
						/>
					</FormItem>
					<Button
						text={getPhrase('submit')}
						onAction={createPasswordChangeAuthenticationCode}
					/>
					<Button
						text={getPhrase('back')}
						type="light"
						margin="4px 40px"
						onAction={reset}
					/>
					<FormFooter>
						{getPhrase('troubleChangingPasswordOrSigningIn')}
						<Div marginTop="16px">
							<EmailAddress preset="intergram" margin="2px 24px 2px 0px"/>
							<PhoneNumber preset="intergram" withHours/>
						</Div>
					</FormFooter>
				</Form>
			</>
		);
	}
}

const FormHint = styled.div`
	font-size: 16px;
	font-weight: 400;
	line-height: 30px;
	margin-bottom: 40px;
	color: ${props => props.theme.disabledTextColor};
`;

const Div = styled.div`
	margin-top: ${props => props.marginTop};
	> a {
		vertical-align: top;
		&.emailAddress {
			top: -2px;
		}
	}
`;

const FormFooter = styled.div`
	margin-top: 40px;
	padding-top: 24px;
	border-top: 1px solid ${props => props.theme.pageSeparatorColor};
`;
